import { TransactionStatus } from '@principle-theorem/principle-core/interfaces';
import {
  IBigQueryFirestoreModel,
  IBigQueryReffable,
  IKeyValuePair,
  ITimestampedDimension,
} from './common';

export interface ITransactionDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    ITimestampedDimension {
  uid: string;
  provider: string;
  reference: string;
  type: string;
  status: TransactionStatus;
  from: string;
  to: string;
  amount: number;
  providerSubType?: IKeyValuePair;
  // extendedData?: T; // Omitted as unnecessary for now. They may want to report on external data in the future.
}
